import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import styled from "styled-components"
import { FaCar, FaStore, FaPhone } from "react-icons/fa"
const ButtonHolder = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  padding: 12px 0 16px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.75) 0%, rgba(0, 0, 0, 0.95) 100%);
  backdrop-filter: blur(8px);
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.4);

  h4 {
    margin: 0 0 8px;
    font-family: 'Oswald', Arial, sans-serif;
    font-size: 13px;
    font-weight: 400;
    text-transform: uppercase;
    letter-spacing: 3px;
    color: rgba(255, 255, 255, 0.7);
  }

  .buttons {
    display: flex;
    justify-content: center;
    gap: 12px;
  }

  a {
    display: inline-flex;
    align-items: center;
    padding: 10px 24px;
    border-radius: 50px;
    background: linear-gradient(180deg, #ff2745 0%, #c41230 100%);
    color: white;
    font-family: 'Oswald', Arial, sans-serif;
    font-size: 18px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 1px;
    text-decoration: none;
    border: none;
    box-shadow: 0 4px 12px rgba(229, 25, 55, 0.4);
    transition: transform 0.15s ease, box-shadow 0.15s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 16px rgba(229, 25, 55, 0.5);
    }

    &:active {
      transform: translateY(0);
    }
  }

  .fa {
    margin-left: 8px;
    font-size: 16px;
  }
`

const OrderButtons = props => {
  const data = useStaticQuery(graphql`
    query OrderButtonQuery {
      allVenue {
        nodes {
          ID_clients
          phone
          externalServices {
            name
            url
          }
        }
      }
    }
  `)

  const ID_clients = props.ID_clients ?? "56"
  const showPhone = props.showPhone ?? false
  const venues = data.allVenue.nodes ?? []

  let deliveryUrl = `//mamaspizza.order.online/business/-28368/?delivery=true`
  const venue = venues.find(v => v.ID_clients == ID_clients) ?? {}

  if (ID_clients !== "56") {
    const externalServices = venue.externalServices ?? []
    deliveryUrl =
      externalServices.find(s => s.name === "doordash-storefront")?.url ?? ""
  }

  return (
    <ButtonHolder>
      <h4>Order Online</h4>
      <div className="buttons">
        {showPhone && venue.phone && (
          <a href={`tel:${venue.phone}`}>
            <span>{venue.phone}</span>
            <FaPhone className="fa"></FaPhone>
          </a>
        )}
        <a
          key="pickup"
          rel="noopener noreferrer"
          aria-label="Mamas Pickup"
          target="_blank"
          href={`//order.mamaspizzas.net`}
        >
          <span>Pickup</span>
          <FaStore className="fa"></FaStore>
        </a>
        <a
          key="delivery"
          rel="noopener noreferrer"
          aria-label="Mamas Delivery"
          target="_blank"
          href={deliveryUrl}
        >
          <span>Delivery</span>
          <FaCar className="fa"></FaCar>
        </a>
      </div>
    </ButtonHolder>
  )
}

export default OrderButtons
